import React from "react";
import "./wminput.css";

function Wminput({ placeholder, maxlength, type, name, onChange, id, list, required, value, className, disabled,autoFocus,autocomplete }) {
  return (
    <React.Fragment>
      <input
        className={`wm_form_input border-bottom border-gray-300 ${className}`}
        type={type}
        id={id}
        list={list}
        placeholder={placeholder}
        onChange={onChange}
        name={name}
        value={value}
        required ={required}
        disabled={disabled}
        autoFocus={autoFocus}
        autoComplete={autocomplete}
        maxLength={maxlength}
      />
      <datalist id="institution">
        <option value="Valia" />
        <option value="UPG" />
        <option value="NMIMS" />
        <option value="Bhavan's" />
      </datalist>
    </React.Fragment>
  );
}

export default Wminput;
